import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  useMemo,
} from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import ModalComponent from "./ModalComponent";
import { useDispatch, useSelector } from "react-redux";
import CONSTANTS from "../util/constants";
import { DataInput } from "./DataComponent";
import * as XLSX from "xlsx";
import Encrypt from "./../util/encrypt";
import DeleteModalComponent from "./DeleteModalCompo";

const DriversComp = () => {
  const gridRef = useRef();

  const dispatch = useDispatch();
  const rowData = useSelector((state) => state.userManagement.getUserData);
  const [modalShow, isModalShow] = useState(false);
  const [isShowModalCancel, setIsShowModalCancel] = useState(false);

  const [cellData, setCellClickData] = useState(null);
  const [columnDefs, setColumnDef] = useState([]);
  const [rowDataDriver, setRowDataDriver] = useState([]);
  const divisionSelectedTemp = useSelector(
    (state) => state.division.divisionSelected
  );
  const [loginResponse, setLoginResponse] = useState(null);

  useEffect(() => {
    let localstorageLR = localStorage.getItem("L_R");
    if (localstorageLR) {
      let data = localstorageLR ? Encrypt.dycryptData(localstorageLR) : "";
      let loginResponse = localstorageLR
        ? JSON.parse(data) != "" || JSON.parse(data) != null
          ? JSON.parse(data)
          : ""
        : "";
      setLoginResponse(loginResponse);
    }

    setCellClickData(null);

    dispatch({
      type: CONSTANTS.CONSTANTS_USER_MANAGEMENT.GET_USER_MANAGEMENT_API_CALL,
    });
  }, []);

  useEffect(() => {
    if (rowData && rowData.length > 0 && rowData != "Failed") {
      let driverUser = rowData?.map((element) => {
        return {
          ...element,
          subElements: element.userRoles.filter(
            (subElement) =>
              subElement.user_role_name == CONSTANTS.CONSTANTS_USER_ROLES.DRIVER
          ),
        };
      });
      if (driverUser && driverUser.length > 0) {
        let rowDataDriverUser = driverUser?.filter((element) => {
          return element?.subElements?.length > 0;
        });
        let filterDataDriver = rowDataDriverUser?.filter((item) => {
          return (
            divisionSelectedTemp?.value == item.division_id &&
            item?.is_active == true
          );
        });
        setRowDataDriver(filterDataDriver);
      }
    }
  }, [rowData]);

  useEffect(() => {
    let localstorageLR = localStorage.getItem("L_R");
    if (localstorageLR) {
      let data = localstorageLR ? Encrypt.dycryptData(localstorageLR) : "";
      let loginResponse = localstorageLR
        ? JSON.parse(data) != "" || JSON.parse(data) != null
          ? JSON.parse(data)
          : ""
        : "";
      setLoginResponse(loginResponse);
    }
    setCellClickData(null);

    dispatch({
      type: CONSTANTS.CONSTANTS_USER_MANAGEMENT
        .GET_USER_ROLES_MANAGEMENT_API_CALL,
    });
  }, []);

  useEffect(() => {
    setColumnDef([
      {
        headerName: "Contact Info",
        children: [
          {
            field: "firstName",
            filter: true,
            resizable: true,
            flex: 1,
            width: 100,
            minWidth: 150,
            maxWidth: 200,
          },
          {
            field: "lastName",
            filter: true,
            resizable: true,
            flex: 1,
            width: 100,
            minWidth: 150,
            maxWidth: 200,
          },
          {
            field: "email",
            filter: true,
            resizable: true,
            flex: 1,
            width: 100,
            minWidth: 250,
            maxWidth: 200,
          },
        ],
      },
      {
        headerName:
          loginResponse &&
          (loginResponse?.user?.userRoles[0]?.user_role_name ==
            CONSTANTS.CONSTANTS_USER_ROLES.DRIVER ||
            loginResponse?.user?.userRoles[0]?.user_role_name ==
              CONSTANTS.CONSTANTS_USER_ROLES.ADMIN ||
            loginResponse?.user?.userRoles[0]?.user_role_name ==
              CONSTANTS.CONSTANTS_USER_ROLES.RHADMIN)
            ? "Actions"
            : "",
        children: [
          {
            field: "Edit",
            filter: true,
            resizable: true,
            flex: 1,
            cellRenderer: cellImageRender,
            width: 100,
            minWidth: 150,
            maxWidth: 200,
          },
          {
            field: "Delete",
            filter: true,
            resizable: true,
            flex: 1,
            cellRenderer: cellCancelImageRender,
            width: 100,
            minWidth: 150,
            maxWidth: 200,
          },
        ],
      },
    ]);
  }, [loginResponse]);

  const cellImageRender = (params) => {
    return loginResponse &&
      (loginResponse?.user?.userRoles[0]?.user_role_name ==
        CONSTANTS.CONSTANTS_USER_ROLES.DRIVER ||
        loginResponse?.user?.userRoles[0]?.user_role_name ==
          CONSTANTS.CONSTANTS_USER_ROLES.ADMIN ||
        loginResponse?.user?.userRoles[0]?.user_role_name ==
          CONSTANTS.CONSTANTS_USER_ROLES.RHADMIN) ? (
      <div
        onClick={() => {
          setCellClickData(params?.data);
          showModal(true);
        }}
      >
        <img
          style={{ marginLeft: 20 }}
          src={require("./../assets/Dashboard/actions.png")}
        />
      </div>
    ) : null;
  };

  const cellCancelImageRender = (params) => {
    return loginResponse &&
      (loginResponse?.user?.userRoles[0]?.user_role_name ==
        CONSTANTS.CONSTANTS_USER_ROLES.DRIVER ||
        loginResponse?.user?.userRoles[0]?.user_role_name ==
          CONSTANTS.CONSTANTS_USER_ROLES.ADMIN ||
        loginResponse?.user?.userRoles[0]?.user_role_name ==
          CONSTANTS.CONSTANTS_USER_ROLES.RHADMIN) ? (
      <div
        onClick={() => {
          setCellClickData(params?.data);
          setIsShowModalCancel(true);
        }}
      >
        <img
          style={{ marginLeft: 20 }}
          src={require("./../assets/Dashboard/cancel.png")}
        />
      </div>
    ) : null;
  };

  const defaultColDef = useMemo(() => ({
    sortable: true,
    resizable: true,
  }));

  const cellClickedListener = useCallback((event) => {}, []);

  const showModal = (isShow) => {
    isModalShow(isShow);
  };

  const showModalCancel = (isShow) => {
    setIsShowModalCancel(isShow);
  };

  const importUser = (file) => {
    const reader = new FileReader();
    const rABS = !!reader.readAsBinaryString;
    reader.onload = (e) => {
      /* Parse data */

      const bstr = e.target.result;
      const wb = XLSX.read(bstr, { type: rABS ? "binary" : "array" });
      /* Get first worksheet */
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      /* Convert array of arrays */
      const data = XLSX.utils.sheet_to_json(ws, { header: 0 });
      /* Update state */
      if (data && data.length > 0) {
        let payload = [];
        for (let i = 0; i < data.length; i++) {
          var permissionArr = [];
          if (data[i].permissions != "" && data[i].permissions != null) {
            permissionArr = data[i].permissions.split(",");
          }
          payload.push({
            email: data[i].email,
            firstName: data[i].firstName,
            lastName: data[i].lastName,
            password: data[i].password,
            permissions: permissionArr,
          });
        }
        dispatch({
          type: CONSTANTS.CONSTANTS_WORKSHEET_MANAGEMENT.USER_BULK_API_CALL,
          payload: { value: payload },
        });
      } else {
        alert("Failed to load data");
      }
    };
    if (rABS) reader.readAsBinaryString(file);
    else reader.readAsArrayBuffer(file);
  };

  return (
    <div className="row">
      {modalShow ? (
        <ModalComponent
          title={cellData != null ? "Edit Driver" : "Create New Driver"}
          show={showModal}
          handleClose={showModal}
          isShow={showModal}
          rowDataUser={cellData}
          driverManagement={true}
          setValue={(value) => {
            isModalShow(false);
            if (cellData != null) {
              setCellClickData(null);
              dispatch({
                type: CONSTANTS.CONSTANTS_USER_MANAGEMENT
                  .EDIT_USER_MANAGEMENT_API_CALL,
                payload: { value: value },
              });
            } else {
              dispatch({
                type: CONSTANTS.CONSTANTS_USER_MANAGEMENT
                  .ADD_USER_MANAGEMENT_API_CALL,
                payload: { value: value },
              });
            }
          }}
        />
      ) : null}

      {isShowModalCancel ? (
        <DeleteModalComponent
          title={"Delete User?"}
          show={showModalCancel}
          handleClose={false}
          isShow={showModalCancel}
          rowDataUser={cellData}
          driverManagement={true}
          data={cellData}
          setValue={(value) => {
            setIsShowModalCancel(false);
            if (cellData != null) {
              setCellClickData(null);
              dispatch({
                type: CONSTANTS.CONSTANTS_USER_MANAGEMENT
                  .EDIT_USER_MANAGEMENT_API_CALL,
                payload: { value: value },
              });
            }
          }}
        />
      ) : null}

      <div className="col-md-12 col-sm-12 col-12">
        {loginResponse &&
        (loginResponse?.user?.userRoles[0]?.user_role_name ==
          CONSTANTS.CONSTANTS_USER_ROLES.ADMIN ||
          loginResponse?.user?.userRoles[0]?.user_role_name ==
            CONSTANTS.CONSTANTS_USER_ROLES.RHADMIN) ? (
          <div
            onClick={() => {
              isModalShow(true);
              setCellClickData(null);
            }}
            className="col-md-12 col-sm-12 row-4 icon icon-shape icon-l  me-12"
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "flex-end",
              margin: "2px 0 2px 0px",
            }}
          >
            <DataInput handleFile={importUser} />
            <img
              src={require("./../assets/Dashboard/plus.png")}
              style={{
                display: "flex",
                alignItems: "flex-end",
                justifyContent: "flex-end",
              }}
            ></img>
          </div>
        ) : null}

        <div
          className="col-md-12 col-sm-12 row-10 ag-theme-alpine"
          style={{
            height: "80vh",
            width: "80vw",
            margin: "auto",
          }}
        >
          {rowDataDriver && rowDataDriver?.length > 0 ? (
            <AgGridReact
              ref={gridRef}
              suppressColumnVirtualisation={true}
              defaultColDef={defaultColDef}
              animateRows={true}
              rowSelection="multiple"
              onCellClicked={cellClickedListener}
              rowData={rowDataDriver}
              columnDefs={columnDefs}
            ></AgGridReact>
          ) : (
            <label>{"No data available"}</label>
          )}
        </div>
      </div>
    </div>
  );
};

export default DriversComp;
